"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrapperContentSection = void 0;
var react_1 = __importDefault(require("react"));
var grainhomecover_png_1 = __importDefault(require("../../../../../assets/images/grainhomecover.png"));
var homecoverimage_png_1 = __importDefault(require("../../../../../assets/images/homecoverimage.png"));
var styled_1 = require("./styled");
var WrapperContentSection = function (_a) {
    var children = _a.children, theme = _a.theme;
    return (react_1.default.createElement(styled_1.StyledContentWrapperCover, null,
        react_1.default.createElement(styled_1.StyledImageLayer, { style: { borderRadius: '1rem' } },
            react_1.default.createElement(styled_1.StyledImage, { src: grainhomecover_png_1.default, style: { borderRadius: '1rem', mixBlendMode: "multiply", opacity: "1" } })),
        react_1.default.createElement(styled_1.StyledColorOverlay, { theme: theme }),
        react_1.default.createElement(styled_1.StyledImageLayer, { style: { borderRadius: '1rem' } },
            react_1.default.createElement(styled_1.StyledImage, { src: homecoverimage_png_1.default, style: { borderRadius: '1rem', mixBlendMode: "lighten", opacity: "0.6" } })),
        react_1.default.createElement("div", { style: { position: "absolute", top: 0, left: 0, width: '100%', height: '100%' } }, children)));
};
exports.WrapperContentSection = WrapperContentSection;
